import "./app.scss";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import Home from "./pages/home/home";

function App() {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      scriptProps={{
        async: false, // optional, default to false
        defer: false, // optional, default to false
        appendTo: "head", // optional, default to "head", can be "head" or "body"
        nonce: undefined, // optional, default undefined
      }}
    >
      <div className="app">
        <Home />
      </div>
    </GoogleReCaptchaProvider>
  );
}

export default App;
